import * as React from "react";

export default () => {
  return <div>Ställ in övergripande import inställningar</div>;
};
